// Helpers for pushing events onto the Google Tag Manager dataLayer.
//
// The site's forms submit over AJAX and call preventDefault(), so the browser
// never performs a native form submission. GTM's built-in Form Submission
// trigger has nothing to listen for, which is why form conversions were coming
// back empty. Every form instead pushes an explicit event here and GTM picks it
// up with a Custom Event trigger.

export const FORM_SUBMISSION_EVENT = 'form_submission';

// Safe to call during SSR (no-ops) and before the GTM snippet has initialised —
// dataLayer is a plain queue, so anything pushed early is replayed once the
// container loads.
export function pushDataLayerEvent(event, payload = {}) {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
}

// Fired once per successful lead submission, after the form provider has
// accepted it. Deliberately carries no personal data — name, email, phone and
// the message stay out of the dataLayer.
export function trackFormSubmission({ formName, formId, formLocation }) {
  if (typeof window === 'undefined') return;

  pushDataLayerEvent(FORM_SUBMISSION_EVENT, {
    form_name: formName,
    form_id: formId,
    form_location: formLocation,
    page_path: window.location.pathname,
    page_location: window.location.href,
  });
}
